import { render, staticRenderFns } from "./ConfirmacionAccion.vue?vue&type=template&id=53a331ec"
import script from "./ConfirmacionAccion.vue?vue&type=script&lang=js"
export * from "./ConfirmacionAccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports